import { SORT_ORDERS } from '../constants/sorting'

export const getSortOrderIcon = sortOrder =>
  `sort ${sortOrder === SORT_ORDERS.desc ? 'descending' : 'ascending'}`

export const getUpdatedSortObject = (value, currentSort) => {
  const sortType = value
  let sortOrder = SORT_ORDERS.asc
  if (value === currentSort.sort.type) {
    sortOrder =
      currentSort.sort.order === sortOrder ? SORT_ORDERS.desc : sortOrder
  }

  return {
    type: sortType,
    order: sortOrder,
  }
}
